// extracted by mini-css-extract-plugin
export default {"products":"Sr-z","card":"Tr-z","oosMessaging":"Ur-z"};